















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";

import ReimburseMeForm from "@/employee/components/ReimburseMeForm.vue";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    ReimburseMeForm
  }
})
export default class ReimburseMePopup extends Vue {
  themeStore = useThemeStore();

  @Prop()
  prefill: number;

  @Prop()
  expenseIds: number [];

  @Prop()
  showPopup: boolean;

  @Prop()
  onPopupClose: () => void;

  @Prop()
  onSubmit: () => void;

  showReimburseMeModal = false;

  @Watch("showPopup")
  setReimburseMePopup () {
    this.showReimburseMeModal = this.showPopup;
  }

  onHidden (e) {
    this.showReimburseMeModal = false;
    this.onPopupClose();
  }

}
